/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Feed_Url_Hint_UsersInputs */

const cs_import_feed_url_hint_users = /** @type {(inputs: Import_Feed_Url_Hint_UsersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vložte GetUserStamps.php (všichni makléři) nebo GetUser.php?export_id=…`)
};

const en_import_feed_url_hint_users = /** @type {(inputs: Import_Feed_Url_Hint_UsersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste GetUserStamps.php (all brokers) or GetUser.php?export_id=…`)
};

/**
* | output |
* | --- |
* | "Paste GetUserStamps.php (all brokers) or GetUser.php?export_id=…" |
*
* @param {Import_Feed_Url_Hint_UsersInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_feed_url_hint_users = /** @type {((inputs?: Import_Feed_Url_Hint_UsersInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Feed_Url_Hint_UsersInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_feed_url_hint_users(inputs)
	return cs_import_feed_url_hint_users(inputs)
});